import { AxiosResponse } from 'axios';

import { Scheduler, SchedulerBody } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostScheduler extends ResponseREST {
	data: Array<Scheduler>;
}

export const postScheduler = async (
	body: Omit<SchedulerBody, 'idScheduler' | 'active'>,
): Promise<ResponseSuccessPostScheduler> => {
	return axiosInstance
		.post('add-scheduler', body)
		.then((res: AxiosResponse<ResponseSuccessPostScheduler>) => res.data)
		.catch((err) => err);
};
